module.exports = __webpack_public_path__ + "5e78bdce7f097f36df6e3163d801923e.png";